module.exports = __webpack_public_path__ + "static/media/img_qudao4@2x.8f2a198d.png";